import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, InputAdornment, TextFieldProps } from "@mui/material";
import { useState } from "react";
import Input from "../Input";
import { LOGIN_TOKENS } from "../../tokens/design-tokens";

type PasswordInputProps = {
  value?: string;
  onChange?: (v: string) => void;
  label?: string;
  error?: string | boolean;
  placeholder?: string;
  withinLabel?: boolean;
} & Omit<TextFieldProps, "error" | "value" | "onChange" | "placeholder">;

const PasswordInput = ({
  value,
  onChange,
  label,
  error,
  placeholder = "*********",
  withinLabel = false,
  ...others
}: PasswordInputProps) => {
  // manage pass visibility internally rather than outer control
  const [isPassVisible, setIsPassVisible] = useState<boolean>(false);

  return (
    <Box>
      <Input
        label={label}
        required={others?.required}
        error={error}
        textFieldProps={{
          ...others,
          value,
          required: false,
          placeholder,
          onChange: (e) => onChange?.(e.currentTarget.value),
          InputProps: {
            type: isPassVisible ? undefined : "password",
            endAdornment: (
              <InputAdornment position="end">
                {/* <IconButton
                  onClick={() => setIsPassVisible((prev) => !prev)}
                  edge="end"
                  size="small"
                > */}
                {/* change icons as per requirement */}
                {isPassVisible ? (
                  <VisibilityOff
                    onClick={() => setIsPassVisible(false)}
                    sx={eyeIconStyle}
                  />
                ) : (
                  <Visibility
                    onClick={() => setIsPassVisible(true)}
                    sx={eyeIconStyle}
                  />
                )}
                {/* </IconButton> */}
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
};

export default PasswordInput;

const eyeIconStyle = {
  cursor: "pointer",
  color: LOGIN_TOKENS.color.iconGrey,
  fontSize: LOGIN_TOKENS.fontSize.iconSm,
};
